import React, { Component } from 'react';
import { handleTouchStart, handleTouchMove } from '../lib/touchScreen';

class Content extends Component {

    componentDidMount = () =>{
        document.getElementById("content").addEventListener('touchstart', handleTouchStart, false);
        document.getElementById("content").addEventListener('touchmove', (e) => {handleTouchMove(e, this.props)}, false);
    }

    render() {
        // let languages = ["AA_FR", "AA_FREN", "AA_GER", "AA_GERM", "AA_SP", "AA_SPAN", "AG_FR", "AG_FREN", "AG_GER", "AG_GERM", "AG_SP", "AG_SPAN"]; //TODO - THIS IS NOT MAINTAINABLE!!!
        // let subject = this.props.subject;
        let option = this.props.option;
        // let resource = this.props.resourceContent;
        let display;
        let liveDisplay;
        if (option !== "resources") {;
            display = this.props.displayContent;
            liveDisplay =  <div dangerouslySetInnerHTML={{ __html: display[option] }}></div>;
        } else {
            liveDisplay = <div></div>
            //display = resource.res;
            //liveDisplay = <div id="resources-link" onClick={toggleResourcePlayer}>Click here to open resource</div>
            //liveDisplay = <a id="resources-link" href={display} target="_blank"  rel="noopener noreferrer">Click here to open resource</a>
            /*liveDisplay = <Iframe url = {display}
            src=""
            width="400px"
            height="450px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"/>*/
        }
        
        return (
           liveDisplay
        );
    }
}

export default Content;